import { post } from '../../common/axiosClient';

export const changeUserPassword = async (oldPassword: any, newPassword: any) => {
  const data = { oldPassword, newPassword };
  return await post('/user/change-password', data);
};

export const forgotPassword = async (email: string) => {
  const data = { email };
  return await post('/user/forgot-password', data);
};

export const resetPassword = async (email: any, token: any, newPassword: any) => {
  const data = { email, token, newPassword };
  return await post('/user/reset-password', data);
};
